import React from 'react';
import Translate from 'react-translate-component';
import { LoyaltyPointService } from 'frilans-finans';
import PointsTable from './points-table';
import PointsTableHeader from './table-header';

class LoyaltyPointsTables extends React.Component {
  constructor (props) {
    super(props);

    this.state = {
      fetching: true,
      fetchingMore: false,
      fetchError: false,
      pendingPoints: [],
      metaPending: {
        currentPage: 0,
        totalPages: 0
      },
      completePoints: [],
      metaComplete: {
        currentPage: 0,
        totalPages: 0
      },
      pendingRequest: null,
      pendingOpen: false,
      completedOpen: false
    };

    this.fetchPoints = this.fetchPoints.bind(this);
    this.toggleTable = this.toggleTable.bind(this);
    this.handleResponse = this.handleResponse.bind(this);
    this.showMorePendingClick = this.showMorePendingClick.bind(this);
    this.showMoreCompleteClick = this.showMoreCompleteClick.bind(this);
  }

  componentDidMount () {
    this.fetchPoints(false);
    this.fetchPoints(true);
  }

  fetchPoints (paid, getPage = null) {
    this.setState({
      fetching: true
    });
    const page = getPage || 1;
    let pendingRequest;
    if (paid) {
      pendingRequest = LoyaltyPointService
        .getComplete(page);
    } else {
      pendingRequest = LoyaltyPointService
        .getPending(page);
    }
    pendingRequest.promise
      .then(response => {
        this.handleResponse(response, paid);
      })
      .catch(error => {
        if (error.response !== undefined) {
          this.setState({
            fetchError: true
          });
        }
      });
    this.setState({
      pendingRequest: pendingRequest
    });
  }

  handleResponse (response, paid) {
    if (paid) {
      this.handleCompletePoints(response);
    } else {
      this.handlePendingPoints(response);
    }
  }

  handleCompletePoints (response) {
    const completePoints = this.state.completePoints;

    response.collection.forEach((invoice) => completePoints.push(invoice));

    this.setState({
      fetching: false,
      fetchError: false
    });

    if (response.collection) {
      this.setState({
        completePoints: completePoints,
        metaComplete: response.meta
      });
    }
  }

  handlePendingPoints (response) {
    const pendingPoints = this.state.pendingPoints;

    response.collection.forEach((invoice) => pendingPoints.push(invoice));

    this.setState({
      fetching: false,
      fetchError: false
    });

    if (response.collection) {
      this.setState({
        pendingPoints: pendingPoints,
        metaPending: response.meta
      });
    }
  }

  toggleTable (table) {
    if (table === 'upcoming') {
      this.setState({
        pendingOpen: !this.state.pendingOpen
      });
    }

    if (table === 'registered') {
      this.setState({
        completedOpen: !this.state.completedOpen
      });
    }
  }

  showMorePendingClick () {
    this.fetchPoints(false, this.state.metaPending.currentPage + 1);
  }

  showMoreCompleteClick () {
    this.fetchPoints(true, this.state.metaComplete.currentPage + 1);
  }

  render () {
    return (<div className='loyalty-points-tables-container'>
      <Translate className='loyalty-points-tables-title' content='LOYALTY_POINTS_TABLE_TITLE' />
      <PointsTableHeader
        title='LOYALTY_POINTS_TABLE_UPCOMING'
        toggleTable={this.toggleTable}
        tableType='upcoming'
        open={this.state.pendingOpen}
      />
      <PointsTable
        type="pending"
        rows={this.state.pendingPoints}
        open={this.state.pendingOpen}
        metaState={this.state.metaPending}
        fetching={this.state.fetching}
        callback={this.showMorePendingClick}
      />
      <PointsTableHeader
        title='LOYALTY_POINTS_TABLE_REGISTERED'
        toggleTable={this.toggleTable}
        tableType='registered'
        open={this.state.completedOpen}
      />
      <PointsTable
        type="complete"
        rows={this.state.completePoints}
        open={this.state.completedOpen}
        metaState={this.state.metaComplete}
        fetching={this.state.fetching}
        callback={this.showMoreCompleteClick}
      />
    </div>);
  }
}

export default LoyaltyPointsTables;



/** WEBPACK FOOTER **
 ** ./src/views/loyalty-program/points-tables/points-tables.js
 **/